import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "ol/ol.css";
import { Map, View } from "ol";
import VectorLayer from "ol/layer/Vector";
import TileLayer from "ol/layer/Tile";
import LayerImage from "ol/layer/Image";
import VectorSource from "ol/source/Vector";
import SourceImagestatic from "ol/source/ImageStatic";
import XYZ from "ol/source/XYZ";
import { defaults } from "ol/control";
import Attribution from "ol/control/Attribution";
import { transformExtent, fromLonLat, transform, toLonLat } from "ol/proj";
import Projection from "ol/proj/Projection";
// import Point from 'ol/geom/Point'
import { Circle, Point, LineString, GeometryCollection, Polygon } from "ol/geom";
import Style from "ol/style/Style";
import StyleIcon from "ol/style/Icon";
import StyleText from "ol/style/Text";
import StyleFill from "ol/style/Fill";
import StyleStroke from "ol/style/Stroke";
import StyleCircle from "ol/style/Circle";
import { Circle as CircleStyle } from "ol/style";
import Feature from "ol/Feature";
import { GeoJSON } from "ol/format";
import Overlay from "ol/Overlay";
import { all } from "ol/loadingstrategy";
import { Draw, Snap, Modify, Select, DragBox, Translate } from "ol/interaction";
import { platformModifierKeyOnly } from "ol/events/condition";
import { getWidth, boundingExtent, getExtent, getCenter } from "ol/extent";
import * as olRender from "ol/render";
import axios from "axios";
import { gaoDeToBaidu, bd_decrypt, loadScript, getImg } from "@/utils/utils";
import { mapState, mapGetters, mapMutations } from "vuex";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import { getPan, getPinchRotate, getdragPan } from "@/view/map/js/common";
import cdata from "@/view/map/hdmconfigv2/common.js";
let _ = require("lodash");
export default {
  name: "zhejiangmapv2assembly",
  props: {
    id: {
      type: Number,
      default: 0
    },
    zoom: {
      type: Number,
      default: 5
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 28
    },
    center: {
      type: Array,
      default: [116.3683244, 39.915085]
    },
    extent: {
      type: Array,
      default: [73.502355, 3.397162, 135.09567, 53.563269]
    },
    showgdtilelayer: {
      type: Boolean,
      default: false
    },
    showstaticlayer: {
      type: Boolean,
      default: false
    },
    staticimage: {
      type: String,
      default: ""
    },
    showgeojsonlayer: {
      type: Boolean,
      default: false
    },
    geojson: {
      type: Object,
      default: {}
    },
    drawelement: {
      type: Object,
      default: {}
    },
    showroutelayer: {
      type: Boolean,
      default: false
    },
    adcode: {
      type: String,
      default: "100000"
    },
    streetcode: {
      type: String,
      default: ""
    },
    pointlist: {
      type: Array,
      default: []
    },
    scale: {
      type: Boolean,
      default: false
    },
    rotate: {
      type: Boolean,
      default: false
    },
    translate: {
      type: Boolean,
      default: false
    },
    mapstyle: {
      type: Object,
      default: {}
    },
    culturallist: {
      type: Array,
      default: []
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object,
      default: {}
    },
    rotation: {
      type: Number,
      default: 0
    },
    routepoint: {
      type: Array,
      default: []
    }
  },
  components: {},
  meta: {
    title: "openlayermap组件"
  },
  data() {
    return {
      mapcontainer: "",
      map: "",
      iconSource: "",
      iconLayer: [],
      style: {},
      cfeature: null,
      timer: null,
      defaultZoom: 0,
      moveendflag: true,
      drawflag: false,
      drawSource: "",
      drawLayer: [],
      drawsketch: "",
      drawinter: "",
      snapinter: "",
      modifyinter: "",
      helpTooltip: "",
      helpTooltipElement: "",
      deleteflag: false,
      selectinter: "",
      selectedFeatures: [],
      dragboxinter: "",
      drawstyle: {
        color: "rgba(0,0,0,0.5)",
        width: 1,
        lineDash: [2, 2]
      },
      drawtextflag: false,
      drawtextsingleflag: false,
      translateinter: "",
      isnotclick: false,
      currentTextstyle: {
        align: 0,
        // 排列方式 0纵向 1横向
        fontSize: 12,
        color1: "rgba(0, 0, 0, 1)",
        color2: "rgba(123, 33, 33, 1)"
      },
      defaulticon: "https://p.ananas.chaoxing.com/star3/origin/6e34ee5cc29e45f92fc9347bf35febfb.png",
      overlay: "undefined",
      findex: 0,
      CircleRadius: 5,
      lightIcon: [require("@/assets/map/138053/color1.gif"), require("@/assets/map/138053/color2.gif"), require("@/assets/map/138053/color3.gif")],
      hoverImg: "",
      hoverImgList: [],
      routeSource: "",
      routeLayer: [],
      locationSource: "",
      locationLayer: [],
      locationicon: "https://p.ananas.chaoxing.com/star3/origin/8077173b8e82056110d8b5ea170d68c4.png",
      animating: false,
      nowDate: "",
      moveprogress: "",
      geoMarker: "",
      iseditpoint: true,
      selectArr: [],
      pointIcon: "",
      polygonfeature: "",
      linefeature: "",
      nmaxlen: 0,
      viewratio: 0,
      drift: 0,
      increase: 0,
      ih: 26,
      transdiffx: 0,
      transdiffy: 0,
      boxId: 0,
      areaList: [],
      shadowLayers: [],
      hoverLayers: [],
      textLayers: []
    };
  },
  created() {
    loadScript(`${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/js/gifler.min.js`);
  },
  computed: {
    ...mapGetters(["mapv2info"]),
    mapv2infoViewchange() {
      const {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      } = this.mapv2info.view;
      return {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      };
    }
  },
  mounted() {
    this.initMap();
    this.style = this.id === 0 ? this.mapv2info.style : this.mapstyle;
    this.hoverImgList = cdata.customMaphoverImgZj;
    if (this.$route.query.edit) this.iseditpoint = true;
  },
  watch: {
    pointlist: {
      handler(val) {
        console.log("pointlist", val);
        this.createPoint(val);
      },
      deep: true
    },
    showgdtilelayer: {
      handler(val) {
        // console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === "tile") item.setVisible(val);
        });
      },
      deep: true
    },
    staticimage: {
      handler(val) {
        console.log(`staticimage`, val);
        if (val) {
          this.map.getLayers().getArray().forEach(item => {
            if (item.className_ === "static") {
              item.setVisible(true);
              const imageExtent = transformExtent(this.extent, "EPSG:4326", "EPSG:3857");
              const imageProjection = new Projection({
                code: "xkcd-image",
                units: "pixels",
                extent: imageExtent
              });
              item.setSource(new SourceImagestatic({
                url: val,
                projection: imageProjection,
                imageExtent: imageExtent
              }));
            }
            if (item.className_ === "json") item.setOpacity(0);
          });
        }
      },
      deep: true
    },
    culturallist: {
      handler(val) {
        console.log(`culturallist`);
        console.log(val);
        this.createculturalPoint(val);
        this.drawAreaList();
        if (this.iseditpoint) this.addDrawInteractions1();
      },
      deep: true
    },
    showroutelayer: {
      handler(val) {
        console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === "route") item.setVisible(val);
        });
      },
      deep: true
    },
    location: {
      handler(val) {
        this.loadLocation(val);
      },
      deep: true
    },
    routepoint: {
      handler(val) {
        this.iconSource.clear();
        this.routeSource.clear();
        if (val.length > 0) this.createPoint(val);
        // else {
        //   this.createPoint(this.pointlist)
        // }
      },
      deep: true
    },
    "mapv2info.style.pointpic": {
      handler(val) {
        console.log(`mapv2info.style.pointpic`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
        if (this.mapv2info.form.cTemplateScore === 1) this.createculturalPoint(this.culturallist);
      },
      deep: true
    },
    "mapv2info.style.pointicon": {
      handler(val) {
        // console.log(`mapv2info.style.pointicon`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    "mapv2info.style.pointtext": {
      handler(val) {
        // console.log(`mapv2info.style.pointtext`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    "mapv2info.style.pointStyleIndex"(val) {
      // console.log(`mapv2info.style.pointStyleIndex`, val);
      this.iconSource.clear();
      this.createPoint(this.pointlist);
    },
    "mapv2info.style.showroute"(val) {
      // console.log(`mapv2info.style.showroute`, val);
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === "route") item.setVisible(val === 1 ? true : false);
      });
      this.createRoute(this.mapv2info.routeSources);
    },
    mapv2infoViewchange() {
      this.updateMap();
    },
    "mapv2info.view.scale"(val) {
      // console.log(`mapv2info.view.scale`, val);
      val ? getPan(this.map) : getPan(this.map, true);
    },
    "mapv2info.view.rotate"(val) {
      // console.log(`mapv2info.view.rotate`, val);
      val ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
    },
    "mapv2info.view.translate"(val) {
      // console.log(`mapv2info.view.translate`, val);
      val ? getdragPan(this.map) : getdragPan(this.map, true);
    },
    "mapv2info.drawlayer.toolsIndex"(val) {
      // 操作类型 0绘制文字 1绘制线 2删除 3框选 4平移
      console.log(`mapv2info.drawlayer.toolsIndex`, val);
      if (val === "") return;
      this.changeToolHandle(val);
    },
    "mapv2info.drawlayer.linestyle"(val) {
      // console.log('mapv2info.drawlayer.linestyle')
      // console.log(val)
      if (val) {
        this.drawstyle = val;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.getGeometry().getType() === "LineString") feature.setStyle(new Style({
            stroke: new StyleStroke(val)
          }));
          if (feature.getGeometry().getType() === "Circle") feature.setStyle(new Style({
            fill: new StyleFill({
              color: val.color
            }),
            stroke: new StyleStroke({
              color: val.color,
              width: this.CircleRadius
            })
          }));
        });
      }
    },
    "mapv2info.drawlayer.currentList"(val) {
      // console.log('mapv2info.drawlayer.currentList')
      this.createText(val, "currentList");
    },
    "mapv2info.drawlayer.drawtextblocksum"(val) {
      // console.log('mapv2info.drawlayer.drawtextblocksum', val)
      this.createText(val, "drawtextblocksum");
    },
    "mapv2info.drawlayer.showtranfer"(val) {
      // console.log('mapv2info.drawlayer.showtranfer', val)
      if (!val && this.mapv2info.drawlayer.dtext) this.showtexthelp();
    },
    "mapv2info.drawlayer.currentTextstyle": {
      handler(val) {
        // console.log('mapv2info.drawlayer.currentTextstyle')
        // console.log(val)
        if (val) {
          this.currentTextstyle = val;
          this.createText(this.mapv2info.drawlayer.currentList, "currentList");
        }
      },
      deep: true
    },
    "mapv2info.routeSources": {
      handler(val) {
        if (!this.showroutelayer) return;
        this.createRoute(val);
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(["SET_MAPDRAWLAYERITEM"]),
    /**
     * 初始化地图
     */
    initMap() {
      console.log("初始化地图", this.zoom);
      this.defaultZoom = Math.round(this.zoom);
      const defaultlayer = this.getTileLayer();
      const staticImageLayer = this.getstaticImageLayer();
      const jsonlayer = this.getjsonlayer();
      const hoverLayer = this.gethoverLayer();

      // 地图地点图层
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource,
        className: "icon",
        zIndex: 6
      });

      // 地图路线图层
      this.routeSource = new VectorSource();
      this.routeLayer = new VectorLayer({
        source: this.routeSource,
        className: "route",
        zIndex: 5
      });
      // 绘制图层
      this.drawLayer = this.getDrawLayer();
      this.drawSource.on("change", evt => {
        this.drawSourceChange(evt);
      });

      // 地图地点图层
      this.locationSource = new VectorSource();
      this.locationLayer = new VectorLayer({
        source: this.locationSource,
        className: "location",
        zIndex: 8
      });
      this.mapcontainer = this.$refs[`map${this.id}`];
      let that = this;
      const gradient = this.lerpColor("#1763B5", "#1E89ED", 20);
      let apiurl = `${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/data/`;
      let baseShadowVector = new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: `${apiurl}330000.json`
        }),
        style: new Style({
          renderer(coordinate, state) {
            //console.log("coordinate", coordinate);
            //console.log("state", state);
            coordinate.forEach(item => {
              let arr = item[0];
              const ctx = state.context;
              gradient.forEach((color, index) => {
                // //console.log("color", color);
                that.addOutlineShadow(ctx, {
                  coodArr: arr,
                  fillStyle: color,
                  y: -index + 20
                  // y: -(index - 2),
                });
              });
            });
          }
        }),
        opacity: 1,
        className: "singlejson",
        zIndex: 2
      });
      console.log(`this.rotation`, this.rotation);
      // jsonlayer,
      this.map = new Map({
        layers: [defaultlayer, baseShadowVector, staticImageLayer, hoverLayer, jsonlayer, this.routeLayer, this.iconLayer, this.drawLayer, this.locationLayer],
        target: this.mapcontainer,
        view: new View({
          center: transform(this.center, "EPSG:4326", "EPSG:3857"),
          minZoom: this.minZoom,
          maxZoom: this.maxZoom,
          zoom: this.zoom,
          rotation: this.rotation
        }),
        controls: defaults({
          attribution: false
        })
      });
      this.scale ? getPan(this.map) : getPan(this.map, true);
      this.rotate ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
      this.translate ? getdragPan(this.map) : getdragPan(this.map, true);
      this.map.on("singleclick", this.singleclick);
      this.map.on("click", this.markerclick);
      this.map.on("pointermove", this.markermove);
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === "tile") item.setVisible(this.showgdtilelayer);
        if (item.className_ === "static") item.setVisible(this.showstaticlayer);
        if (item.className_ === "json") {
          item.setVisible(this.showgeojsonlayer);
          if (this.staticimage) item.setOpacity(0);
        }
        if (item.className_ === "hoverimg") item.setVisible(false);
        if (item.className_ === "route") item.setVisible(this.showroutelayer);
      });
      this.map.on("moveend", this.markermoveend);
    },
    /**
     * 加载高德地图瓦片作为底图
     */
    getTileLayer() {
      return new TileLayer({
        source: new XYZ({
          url: "http://webrd03.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}"
        }),
        className: "tile",
        zIndex: 1
      });
    },
    /**
     * 加载静态图片
     */
    getstaticImageLayer() {
      // 假设你的图层边界在4326下是 [minx, miny, maxx, maxy]
      const layerExtentIn4326 = this.extent;
      // 转换边界的对角点到3857坐标系
      const bottomLeftIn3857 = fromLonLat([layerExtentIn4326[0], layerExtentIn4326[1]]);
      const topRightIn3857 = fromLonLat([layerExtentIn4326[2], layerExtentIn4326[3]]);
      const xOffset = 0; // 向右偏移1000米

      // 创建在3857坐标系下的边界（注意：extent 是 [minx, miny, maxx, maxy]）
      const layerExtentIn3857 = [bottomLeftIn3857[0] + xOffset, bottomLeftIn3857[1], topRightIn3857[0] + xOffset, topRightIn3857[1]];
      return new LayerImage({
        source: new SourceImagestatic({
          url: this.staticimage,
          projection: "EPSG:3857",
          imageExtent: layerExtentIn3857
        }),
        opacity: 1,
        className: "static",
        zIndex: 2
      });
    },
    /**
     * 加载GeoJson
     */
    getjsonlayer() {
      let vectorSource = "";
      if (this.adcode === "region") {
        // 自定义json数据
        vectorSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.geojson)
        });
      } else {
        // 乡镇街道json判断
        if (this.streetcode !== "") {
          vectorSource = new VectorSource({
            features: new GeoJSON().readFeatures(this.geojson)
          });
        } else {
          // 省市区县json
          vectorSource = new VectorSource({
            format: new GeoJSON(),
            url: `${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/data/${this.adcode.includes("_full") ? this.adcode.replace("_full", "") : this.adcode}${this.mapv2info.form.ishaschild === "是" ? "_full" : ""}.json`
          });
        }
      }
      return new VectorLayer({
        source: vectorSource,
        opacity: 1,
        style: this.jsonstyleFunction(),
        className: "json",
        zIndex: 3
      });
    },
    jsonstyleFunction() {
      return [new Style({
        stroke: new StyleStroke({
          color: "rgba(5, 146, 232, 1)",
          width: 1
        }),
        fill: new StyleFill({
          color: "rgba(5, 146, 232, 0.2)"
        })
      })];
    },
    gethoverLayer() {
      return new LayerImage({
        source: new SourceImagestatic({
          url: this.hoverImg,
          projection: "EPSG:3857",
          imageExtent: []
        }),
        opacity: 1,
        className: "hoverimg",
        zIndex: 4
      });
    },
    /**
     * 绘制图层
     */
    getDrawLayer() {
      this.drawSource = new VectorSource();
      // 非遗地图移动端不显示绘制图层
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawJson) {
        let data = this.drawelement;
        const featureJson = new GeoJSON().readFeatures(data.drawJson);
        featureJson.forEach((feature, index) => {
          if (feature.get("name")) {
            let textstyle = feature.get("style");
            let name = feature.get("name");
            if (textstyle.align === 0) {
              name = name.replace(/\uff08/g, "\ufe35");
              name = name.replace(/\uff09/g, "\ufe36");
              name = name.split("").join("\n");
            } else {
              name = name.replace(/\ufe35/g, "\uff08");
              name = name.replace(/\ufe36/g, "\uff09");
            }
            feature.setStyle(new Style({
              text: new StyleText({
                text: name,
                font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
                textBaseline: "top",
                textAlign: "left",
                fill: new StyleFill({
                  color: textstyle.color
                })
              })
            }));
          }
          if (feature.getGeometry().getType() === "LineString") {
            // let linestyle =
            //     Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            let linestyle = {
              color: "rgba(0, 56, 238, 0.8)",
              // 线条颜色
              width: 4 // 线条宽度
            };

            // 获取线条的坐标
            const coordinates = feature.getGeometry().getCoordinates();
            const startPoint = coordinates[0];
            const endPoint = coordinates[coordinates.length - 1];

            // 创建线条样式
            const lineStyle = new Style({
              stroke: new StyleStroke(linestyle),
              zIndex: 15 // 设置线
            });

            // 图片路径 - 请替换为实际图片路径
            // const startIconUrl = require("@/assets/map/zhejiang/circle.png"); // 起点图标
            // const endIconUrl = require("@/assets/map/zhejiang/circle.png"); // 终点图标
            const startIconUrl = require("@/assets/map/138053/circle.png"); // 起点图标
            const endIconUrl = require("@/assets/map/138053/circle.png"); // 终点图标
            // 创建起点图片样式
            const startIconStyle = new Style({
              geometry: new Point(startPoint),
              image: new StyleIcon({
                src: startIconUrl,
                scale: 0.25,
                // 调整图片大小比例
                anchor: [0.5, 0.5],
                // 锚点位置（图片中心）
                anchorXUnits: "fraction",
                anchorYUnits: "fraction"
              }),
              zIndex: 15 // 设置终点图标的z-index比线条更高
            });

            // 创建终点图片样式
            const endIconStyle = new Style({
              geometry: new Point(endPoint),
              image: new StyleIcon({
                src: endIconUrl,
                scale: 0.25,
                // 调整图片大小比例
                anchor: [0.5, 0.5],
                // 锚点位置（图片中心）
                anchorXUnits: "fraction",
                anchorYUnits: "fraction"
              }),
              zIndex: 15 // 设置终点图标的z-index比线条更高
            });

            // 设置组合样式
            feature.setStyle([lineStyle, startIconStyle, endIconStyle]);
          }
          if (feature.getGeometry().getType() === "GeometryCollection" && feature.get("type") === "circle") {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature = new Feature({
              geometry: new Circle(feature.get("coordinate"), this.CircleRadius),
              type: "circle",
              coordinate: feature.get("coordinate")
            });
            feature.setStyle(new Style({
              fill: new StyleFill({
                color: linestyle.color
              }),
              stroke: new StyleStroke({
                color: linestyle.color,
                width: this.CircleRadius
              })
            }));
          }
          this.drawSource.addFeature(feature);
        });
        if (Object.keys(data.linestyle).length > 0) {
          this.drawstyle = data.linestyle;
        }
      }
      return new VectorLayer({
        source: this.drawSource,
        className: "draw",
        style: new Style({
          stroke: new StyleStroke(this.drawstyle)
        }),
        zIndex: 7
      });
    },
    drawSourceChange(evt) {
      let that = this;
      evt.target.getFeatures().forEach(feature => {
        if (feature.get("dindex") !== undefined) {
          let arrCoordinates = feature.getGeometry().getCoordinates();
          let defaultValue = [...arrCoordinates];
          let coordinates = [];
          // 两点 判断起始点 确定方向 绘制直角直线
          if (arrCoordinates.length === 2) {
            coordinates.push(defaultValue[0]);
            coordinates.push(that.getcurrentCoordinates(defaultValue[0], defaultValue[1]));
          }
          if (arrCoordinates.length > 2) {
            function setCoordinatesArr(i) {
              if (i === 0) {
                coordinates.push(defaultValue[i]);
                setCoordinatesArr(i + 1);
              } else if (i > defaultValue.length - 1) {
                return;
              } else {
                let nextC = that.getcurrentCoordinates(coordinates[i - 1], defaultValue[i]);
                coordinates.push(nextC);
                setCoordinatesArr(i + 1);
              }
            }
            setCoordinatesArr(0);
          }
          let features = [];
          // 创建直角线段的几何对象
          const geometry = new LineString(coordinates);

          // 创建具有直角线段几何对象的特性
          const linefeature = new Feature({
            geometry: geometry,
            findex: feature.get("dindex")
          });

          // 设置线的样式
          linefeature.setStyle(new Style({
            stroke: new StyleStroke(this.drawstyle)
          }));
          let lineStart = coordinates[0];
          let lineEnd = coordinates[coordinates.length - 1];
          let startCircleGeom = new Circle(lineStart, this.CircleRadius);
          let endCircleGeom = new Circle(lineEnd, this.CircleRadius);
          const circleitemStyle = new Style({
            fill: new StyleFill({
              color: this.drawstyle.color
            }),
            stroke: new StyleStroke({
              color: this.drawstyle.color,
              width: this.CircleRadius
            })
          });
          let startfeature = new Feature({
            geometry: startCircleGeom,
            type: "circle",
            coordinate: lineStart
          });
          startfeature.setStyle(circleitemStyle);
          let endfeature = new Feature({
            geometry: endCircleGeom,
            type: "circle",
            coordinate: lineEnd
          });
          endfeature.setStyle(circleitemStyle);
          features = [linefeature, startfeature, endfeature];
          this.drawSource.removeFeature(feature);
          this.drawSource.addFeatures(features);
        }
      });
    },
    /**
     * 更新地图
     */
    updateMap() {
      this.$nextTick(() => {
        console.log("更新地图");
        this.map.getView().setCenter(transform(this.center, "EPSG:4326", "EPSG:3857"));
        this.map.getView().setMinZoom(this.minZoom);
        this.map.getView().setMaxZoom(this.maxZoom);
        this.map.getView().setZoom(this.zoom);

        // 东胜地图添加旋转
        if (this.$route.query.fid === "166970") {
          // this.map.render()
          this.map.getView().on("change:rotation", evt => {
            console.log(evt);
            this.map.updateSize();
          });
          this.map.getView().setRotation(this.rotation);
        }
      });
    },
    /**
     * 单击地图操作
     */
    singleclick(val) {
      // 高德坐标
      let coordinateArr = transform(val.coordinate, "EPSG:3857", "EPSG:4326");

      // 绘制线段 禁止单击
      if (this.drawflag) return;
      // 绘制文字操作
      if (this.drawtextflag) {
        this.drawtextsingleflag = true;
        this.helpTooltipElement.innerHTML === "";
        this.helpTooltipElement.classList.add("hidden");
        if (this.drawtextsingleflag) {
          this.SET_MAPDRAWLAYERITEM({
            showtranfer: true
          });
          this.SET_MAPDRAWLAYERITEM({
            currentCoordinate: coordinateArr
          });
          return;
        }
      }
      console.log("coordinate: " + coordinateArr[0].toFixed(6) + "," + coordinateArr[1].toFixed(6));
      let bdpoint = gaoDeToBaidu(coordinateArr[0].toFixed(6), coordinateArr[1].toFixed(6));
      this.$emit("singleclick", `${bdpoint.lng.toFixed(6)}, ${bdpoint.lat.toFixed(6)}`);
    },
    /**
     * 创建地图点位
     * @param {Array} val 点位数据
     */
    createPoint(val) {
      if (val.length === 0) return;
      let that = this;
      val.forEach(elem => {
        let item = elem.itemformdata;
        let c = item.map_coordinates.split(",");
        let gd = bd_decrypt(Number(c[0]), Number(c[1]));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.place_name,
          image: item[4].length > 0 ? getImg(item[4][0]) : this.defaulticon,
          icon: this.defaulticon
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: obj.icon,
          xy: [x, y],
          score: 0
        });
        if (item[4].length > 0 && item[4][0].suffix === "gif") {
          obj.gif = getImg(item[4][0]);
          this.timer = setInterval(() => {
            if (gifler && that.style.pointStyleIndex) {
              const gifUrl = getImg(item[4][0]);
              const gif = gifler(gifUrl);
              gif.frames(document.createElement("canvas"), function (ctx, frame) {
                if (!pointfeature.getStyle()) {
                  pointfeature.setStyle(that.getStyle(obj, that.style.pointStyleIndex, ctx, frame));
                }
                ctx.clearRect(0, 0, frame.width, frame.height);
                ctx.drawImage(frame.buffer, frame.x, frame.y);
                that.map.render();
              }, true);
              clearInterval(that.timer);
              that.timer = null;
            }
          }, 100);
        } else {
          // console.log(`this.style.pointStyleIndex`, this.style.pointStyleIndex);
          pointfeature.setStyle(this.getStyle(obj, this.style.pointStyleIndex));
        }
        this.iconSource.addFeature(pointfeature);
      });
    },
    /**
     * 设置相应样式
     */
    getStyle(item, sIndex, ctx, frame) {
      // this.pointlist.forEach((e) => {
      //   if(e.itemformdata.place_name==item.name&&e.itemformdata.signcity=="杭州市"){
      //     item.offsetY=200
      //     item.offsetX=-50
      //     console.log('e',e)
      //   }
      // });
      // console.log('item',item)
      let Styles = [];
      let stext = this.style.pointtext;
      let spic = this.style.pointpic;
      let sicon = this.style.pointicon;

      // 绘制圆角矩形
      let textsize = parseInt(stext.fontSize);
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let namelen = item.name.length + 1;
      canvas.width = namelen * textsize;
      canvas.height = textsize + 6;
      let x = 0;
      let y = 0;
      let w = canvas.width;
      let h = canvas.height;
      let r = Math.ceil((textsize + 6) / 2);
      // 缩放
      context.scale(1, 1);
      context.fillStyle = stext.fill;
      // 绘制圆角矩形
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + w, y, x + w, y + h, r);
      context.arcTo(x + w, y + h, x, y + h, r);
      context.arcTo(x, y + h, x, y, r);
      context.arcTo(x, y, x + w, y, r);
      // 设置阴影
      // context.shadowColor = 'rgba(0, 0, 0, 0.2)' // 颜色
      // context.shadowBlur = 5 // 模糊尺寸
      // context.shadowOffsetX = 2 // 阴影Y轴偏移
      // context.shadowOffsetY = 2 // 阴影X轴偏移
      // ----
      context.closePath();
      // 填充
      context.fill();
      let image = "";
      if (ctx) {
        image = new Style({
          image: new StyleIcon({
            img: ctx.canvas,
            opacity: 1,
            imgSize: [frame.width, frame.height],
            // anchor:[4,0.5],
            anchor: this.getAnchor(item.name, spic.anchor),
            //  anchor: window.innerWidth <= 1500 ? [4, 4] : spic.anchor,
            scale: spic.scale,
            rotateWithView: true
          })
        });
      } else {
        image = new Style({
          image: new StyleIcon({
            src: item.image,
            // anchor:[4,0.5],
            anchor: this.getAnchor(item.name, spic.anchor),
            // anchor: window.innerWidth <= 1500 ? [4, 4] : spic.anchor,
            scale: spic.scale,
            rotateWithView: true
          })
        });
      }
      let icon = item.icon !== "" ? new Style({
        image: new StyleIcon({
          src: item.icon,
          anchor: sicon.anchor,
          scale: sicon.scale,
          rotateWithView: true
        })
      }) : "";
      let text = new Style({
        image: new StyleIcon({
          img: canvas,
          imgSize: [w, h],
          rotateWithView: true
        }),
        text: new StyleText({
          textAlign: "center",
          text: item.name,
          font: `${stext.fontSize} sans-serif`,
          offsetY: item.offsetY ? item.offsetY : 0,
          offsetX: item.offsetX ? item.offsetX : 0,
          fill: new StyleFill({
            color: stext.color
          }),
          stroke: stext.stroke !== "" ? new StyleStroke({
            color: stext.stroke,
            width: 1
          }) : "",
          rotateWithView: true
        })
      });
      if (sIndex === 0) {
        Styles.push(image);
        Styles.push(text);
      }
      if (sIndex === 1 || sIndex === 5) Styles.push(image);
      if (sIndex === 2 || sIndex === 7) Styles.push(icon);
      if (sIndex === 3) Styles.push(text);
      if (sIndex === 4 || sIndex === 6) {
        Styles.push(icon);
        Styles.push(text);
      }
      if (sIndex === 8) {
        Styles.push(image);
        Styles.push(icon);
        Styles.push(text);
      }
      return Styles;
    },
    /**
     * 单击点位操作
     */
    markerclick(evt) {
      console.log("click", evt);
      // if (this.isnotclick || this.iseditpoint) return;
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      this.$emit("markerclick", feature);
    },
    // 自定义函数：查找包含文本偏移的要素

    /**
     * 鼠标移入点位操作 动效
     */
    markermove(evt) {
      // 样式的复原操作
      this.pointlist.forEach(e => {
        this.iconSource.getFeatures().forEach(o => {
          if (e.itemformdata.place_name == o.values_.name) {
            o.values_.signcity = e.itemformdata.signcity;
          }
        });
      });
      let sIndex = this.style.pointStyleIndex;
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      this.iconSource.getFeatures().forEach(e => {
        let obj = e.getStyle();
        if (obj[1]) {
          obj[1].text_.fill_ = new StyleFill({
            color: "#333333"
          });
          obj[1].text_.stroke_ = null;
          e.setStyle(obj);
        }
      });
      while (this.shadowLayers.length > 0) {
        const layer = this.shadowLayers.pop(); // 移除最后一个图层的引用
        this.map.removeLayer(layer); // 从地图上移除图层
      }
      while (this.hoverLayers.length > 0) {
        const layer = this.hoverLayers.pop(); // 移除最后一个图层的引用
        this.map.removeLayer(layer); // 从地图上移除图层
      }
      while (this.textLayers.length > 0) {
        const layer = this.textLayers.pop(); // 移除最后一个图层的引用
        this.map.removeLayer(layer); // 从地图上移除图层
      }
      this.map.getTarget().style.cursor = "";
      // console.log("feature", feature);
      // console.log('this.iconSource.getFeatures();',this.iconSource.getFeatures())
      if (feature && feature.get("xy")) {
        this.map.getTarget().style.cursor = "pointer";

        // 设置文字的高亮
        let obj = feature.getStyle();
        if (obj[1]) {
          obj[1].text_.fill_ = new StyleFill({
            color: "rgba(54, 68, 217, 1)"
          });
          obj[1].text_.stroke_ = null;
          feature.setStyle(obj);
        }
        let cid = feature.get("id");
        let allfeatures = this.iconSource.getFeatures();
        allfeatures.forEach(item => {
          let id = item.get("id");
          let obj = {
            name: item.get("name"),
            image: item.get("image"),
            icon: item.get("icon")
          };
          if (cid === id) {
            if (sIndex === 5) feature.setStyle(this.getStyle(obj, 0));
            if (sIndex === 6) feature.setStyle(this.getStyle(obj, 8));
            if (sIndex === 7) feature.setStyle(this.getStyle(obj, 8));
            this.cfeature = feature;
          }
        });
        // console.log("feature", feature);
        // 设置文字划过，城市高亮
        // 这里获取城市的feature
        let allFeatures = [];
        const layers = this.map.getLayers().getArray();
        layers.forEach(layer => {
          if (layer instanceof VectorLayer) {
            const source = layer.getSource();
            if (source) {
              const features = source.getFeatures();
              allFeatures = allFeatures.concat(features);
            }
          }
        });
        let features = allFeatures.filter(e => e.values_.level == "city");
        let currentCityFeature = features.find(e => e.values_.name == feature.values_.signcity);
        if (currentCityFeature) {
          let code = Number(currentCityFeature.get("adcode"));
          let current = this.hoverImgList.find(elem => {
            return elem.code === code;
          });
          let geometry = currentCityFeature.get("geometry");
          let extent = geometry.extent_.map((item, index) => {
            return item;
          });
          // console.log('currentCityFeature')
          // console.log(current)
          // console.log(extent)
          // console.log(currentCityFeature)
          this.changeShadow(currentCityFeature, extent, current);
        }
      }

      // 虹口地图 鼠标移入显示相应地图图片【先定制后通用】
      if (feature && !feature.get("xy")) {
        let code = Number(feature.get("adcode"));
        // console.log('feature',feature)
        // console.log('code',code)
        let geometry = feature.get("geometry");
        let current = this.hoverImgList.find(elem => {
          return elem.code === code;
        });
        // 设置城市划过的文字的高亮
        this.iconSource.getFeatures().forEach(e => {
          if (e.values_ && e.values_.signcity && current && current.city && e.values_.signcity == current.city) {
            let obj = e.getStyle();
            if (obj[1]) {
              obj[1].text_.fill_ = new StyleFill({
                color: "rgba(54, 68, 217, 1)"
              });
              obj[1].text_.stroke_ = null;
              e.setStyle(obj);
            }
          } else {
            let obj = e.getStyle();
            // console.log("obj", obj);
            if (obj[1]) {
              obj[1].text_.fill_ = new StyleFill({
                color: "#333333"
              });
              obj[1].text_.stroke_ = null;
              e.setStyle(obj);
            }
          }
        });
        let extent = geometry.extent_.map((item, index) => {
          return item;
        });
        if (current && extent) {
          this.changeShadow(feature, extent, current);
        }
      }
      if (feature === undefined) {
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === "hoverimg") item.setVisible(false);
        });
      }
    },
    lerpColor(startColor, endColor, stepCount) {
      // 解析颜色值为RGB对象
      function parseColor(color) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }

      // 将RGB对象转换回十六进制字符串
      function rgbToHex({
        r,
        g,
        b
      }) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
      }
      const startRGB = parseColor(startColor);
      const endRGB = parseColor(endColor);
      const gradientColors = [];
      for (let i = 0; i <= stepCount; i++) {
        const ratio = i / stepCount;
        const newR = Math.round(startRGB.r + ratio * (endRGB.r - startRGB.r));
        const newG = Math.round(startRGB.g + ratio * (endRGB.g - startRGB.g));
        const newB = Math.round(startRGB.b + ratio * (endRGB.b - startRGB.b));
        gradientColors.push(rgbToHex({
          r: newR,
          g: newG,
          b: newB
        }));
      }
      return gradientColors;
    },
    changeShadow(feature, extent, current) {
      // console.log("current", current);
      // console.log("feature", feature);
      const upextent = extent.map((item, index) => {
        return index === 1 || index === 3 ? item + 20000 : item;
      });
      const gradient1 = this.lerpColor("#1763B5", "#103D7D", 20);
      const shadowSource = new VectorSource({
        features: [feature]
      });
      // //////console.log("gradient1", gradient1);
      const HoverShadowLayer = new VectorLayer({
        source: new VectorSource(),
        opacity: 1,
        className: "hovershadow",
        zIndex: 3,
        visible: true
      });
      let that = this;
      HoverShadowLayer.setSource(shadowSource);
      HoverShadowLayer.setStyle(new Style({
        renderer(coordinate, state) {
          // //////console.log("coordinate", coordinate);
          // //////console.log("state", state);
          coordinate.forEach(item => {
            let arr = item[0];
            const ctx = state.context;
            gradient1.forEach((color, index) => {
              that.addOutlineShadow(ctx, {
                coodArr: arr,
                fillStyle: color,
                y: -(index - 2)
              });
            });
          });
        }
      }));
      const HoverImageLayer = new LayerImage({
        source: new SourceImagestatic({
          url: current.image ? current.image : current.url,
          projection: "EPSG:3857",
          imageExtent: upextent
        }),
        opacity: 1,
        className: "hover",
        zIndex: 4,
        visible: true
      });
      // 创建文字图层
      // const HoverTextLayer = new VectorLayer({
      //   source: new VectorSource({
      //     features: [
      //       new Feature({
      //         geometry: new Point(
      //           fromLonLat([feature.values_.center[0], feature.values_.center[1]])
      //         ), // 假设存在获取图片中心的方法
      //       }),
      //     ],
      //   }),
      //   style: new Style({
      //     text: new StyleText({
      //       text: current.city, // 从current对象获取文字，或使用默认值
      //       font: "bold 16px Arial",
      //       fill: new StyleFill({ color: "#FFFFFF" }),
      //       stroke: new StyleStroke({ color: "#000000", width: 2 }),
      //       offsetY: 0, // 文字偏移量，可根据需要调整
      //       textAlign: "center",
      //       textBaseline: "middle",
      //     }),
      //   }),
      //   zIndex: 8, // 确保文字显示在图片上方
      //   visible: true,
      // });
      // this.map.addLayer(HoverTextLayer);
      this.map.addLayer(HoverImageLayer);
      this.map.addLayer(HoverShadowLayer);
      // ////console.log("HoverShadowLayer", HoverShadowLayer);
      this.shadowLayers.push(HoverShadowLayer);
      this.hoverLayers.push(HoverImageLayer);
      // this.textLayers.push(HoverTextLayer); // 保存文字图层引用以便后续操作
    },
    /**
     * 地图移动结束操作
     */
    markermoveend(evt) {
      const res = this.map.getView().getResolution();
      // console.log('当前分辨率:', res)
      let zoom = Math.round(this.map.getView().getZoom());
      // console.log('当前zoom:', zoom)
      if (this.defaultZoom === zoom && this.moveendflag) return false;
      if (this.defaultZoom !== zoom) this.defaultZoom = zoom;
      this.$emit("markermoveend", zoom);
    },
    changeToolHandle(val) {
      console.log("changeToolHandle", changeToolHandle);
      if (val !== "") this.isnotclick = true;
      if (val === 0 || val === 6) {
        this.deleteflag = false;
        this.createHelpTooltip();
        if (val === 0) this.showtexthelp();
      } else {
        if (this.helpTooltipElement) {
          this.helpTooltipElement.innerHTML === "";
          this.helpTooltipElement.classList.add("hidden");
        }
      }
      this.drawtextflag = val === 0 ? true : false;
      this.drawflag = val === 6 ? true : false;
      val === 6 ? this.addDrawInteractions() : this.removedrawInteractions();
      if (val === 2) {
        this.deleteflag = true;
        this.deleteDrawInteractions();
      }
      if (val === 3) {
        this.addselectInteraction();
        this.adddragboxInteraction();
      }
      if (val === 4) this.addtranslateInteraction();
    },
    /**
     * 地图添加 draw snap modify 交互效果
     */
    addDrawInteractions() {
      let that = this;
      this.drawinter = new Draw({
        source: this.drawSource,
        type: "LineString",
        style: this.addStyle()
      });
      this.drawinter.on("drawstart", evt => {
        this.drawsketch = evt.feature;
        let sketch = evt.feature;
        sketch.set("dindex", this.findex);
        this.findex++;
      });
      this.drawinter.on("drawend", evt => {
        this.drawsketch = null;
      });
      this.map.addInteraction(this.drawinter);
      this.modifyinter = new Modify({
        source: this.drawSource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.snapinter = new Snap({
        source: this.drawSource
      });
      this.map.addInteraction(this.snapinter);
      this.snapinter.on("snap", event => {
        this.helpTooltipElement.innerHTML = "拖动修改";
      });
    },
    addDrawInteractions1() {
      this.addselectInteraction();
      this.adddragboxInteraction();
    },
    getcurrentCoordinates(a1, a2) {
      let x1 = a1[0];
      let y1 = a1[1];
      let x2 = a2[0];
      let y2 = a2[1];
      let newCoordinate = [];
      if (x2 - x1 >= 0 && y2 - y1 >= 0 || x2 - x1 >= 0 && y2 - y1 <= 0 || x2 - x1 <= 0 && y2 - y1 >= 0 || x2 - x1 <= 0 && y2 - y1 <= 0) {
        if (Math.abs(x2 - x1) > Math.abs(y2 - y1)) {
          newCoordinate = [x2, y1];
        } else {
          newCoordinate = [x1, y2];
        }
      }
      return newCoordinate;
    },
    addStyle() {
      return new Style({
        stroke: new StyleStroke({
          color: "#2B67FF",
          width: 2
        }),
        image: new StyleCircle({
          radius: 5,
          fill: new StyleFill({
            color: "#2B67FF"
          })
        })
      });
    },
    addOutlineShadow(ctx, option) {
      // //////console.log(`option.strokeStyle`, option.strokeStyle)
      // 设置属性控制图形的外观
      ctx.fillStyle = option.fillStyle || "transparent";
      ctx.strokeStyle = option.strokeStyle || "transparent";
      ctx.beginPath();
      let arr = option.coodArr || [];
      for (let i = 0; i < arr.length; i++) {
        const data = arr[i];
        if (i === 0) {
          ctx.moveTo(data[0] - 0, data[1] + option.y);
        } else {
          ctx.lineTo(data[0] - 0, data[1] + option.y);
        }
      }
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    },
    /**
     * 地图移出 draw snap modify 交互效果
     */
    removedrawInteractions() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = "";
      this.map.removeInteraction(this.drawinter);
      this.drawinter = "";
      this.map.removeInteraction(this.snapinter);
      this.snapinter = "";
      this.map.removeInteraction(this.selectinter);
      this.selectinter = "";
      this.map.removeInteraction(this.dragboxinter);
      this.dragboxinter = "";
      this.map.removeInteraction(this.translateinter);
      this.translateinter = "";
    },
    /**
     * 创建提示信息
     */
    createHelpTooltip() {
      if (this.helpTooltipElement) this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      this.helpTooltipElement = document.createElement("div");
      this.helpTooltipElement.className = "ol-tooltip hidden";
      this.helpTooltip = new Overlay({
        element: this.helpTooltipElement,
        offset: [15, 0],
        positioning: "center-left"
      });
      this.map.addOverlay(this.helpTooltip);
    },
    /**
     * 绘制删除操作
     */
    deleteDrawInteractions() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: "请先选择要删除的绘制元素",
          type: "warning"
        });
        return;
      }
      let deletedata = [];
      ElMessageBox.confirm("确定要删除么？", "温馨提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        this.selectedFeatures.getArray().forEach(feature => {
          if (feature.get("name")) deletedata.push({
            key: feature.get("id"),
            label: feature.get("name")
          });
          this.SET_MAPDRAWLAYERITEM({
            deleteList: deletedata
          });
          this.drawSource.removeFeature(feature);
        });
      }).catch(() => {
        this.selectedFeatures.clear();
      });
    },
    adddrawSourceTranslate() {
      let that = this;
      this.translateinter = new Translate({
        features: this.selectinter.getFeatures()
      });
      this.map.addInteraction(this.translateinter);

      /** 拖拽列表区域控制在ICON左侧或右侧  拖拽ICON 整体随之改变位置  **/
      let startCoords, startpolygonCoords, startlineCoords, polygonwidth, startSelectArr, starticonCoords, dragelemtype, dragelemgId;
      this.translateinter.on("translatestart", function (evt) {
        console.log(`translatestart`, evt);
        dragelemtype = evt.features.getArray()[0].get("type");
        dragelemgId = evt.features.getArray()[0].get("id");
        startCoords = evt.startCoordinate;
        starticonCoords = that.pointIcon.getGeometry().getCoordinates();
        startpolygonCoords = that.polygonfeature.getGeometry().getCoordinates();
        startlineCoords = that.linefeature.getGeometry().getCoordinates();
        polygonwidth = startpolygonCoords[0][1][0] - startpolygonCoords[0][0][0];
        startSelectArr = _.cloneDeep(that.selectArr);
      });
      this.translateinter.on("translating", function (evt) {
        that.transdiffx = evt.coordinate[0] - startCoords[0];
        that.transdiffy = evt.coordinate[1] - startCoords[1];
        let translatepolygonCoords = startpolygonCoords[0].map(item => {
          return [item[0] + that.transdiffx, item[1] + (dragelemtype === "areaicon" ? that.transdiffy : 0)];
        });
        that.polygonfeature.setGeometry(new Polygon([translatepolygonCoords]));
        that.selectArr.forEach((elem, index) => {
          let select = startSelectArr[index].getGeometry().getCoordinates();
          elem.getGeometry().setCoordinates([select[0] + that.transdiffx, select[1] + (dragelemtype === "areaicon" ? that.transdiffy : 0)]);
        });

        /** 判断polygon在pointIcon 左侧(false)或右侧(true) **/
        let direction = evt.coordinate[0] > startlineCoords[0][0];
        let translatelineCoords;
        if (dragelemtype === "areaicon") {
          translatelineCoords = startlineCoords.map((item, index) => {
            return [item[0] + that.transdiffx, item[1] + that.transdiffy];
          });
        } else {
          translatelineCoords = startlineCoords.map((item, index) => {
            if (index === 1) item = [translatepolygonCoords[1][0] - (direction ? polygonwidth : 0), item[1]];
            return item;
          });
        }
        that.linefeature.setGeometry(new LineString(translatelineCoords));
      });
      this.translateinter.on("translateend", function (evt) {
        let areaIndex = that.areaList.findIndex(item => {
          return item.id === dragelemgId;
        });
        that.areaList[areaIndex].datafirstcenter = that.selectArr[0].getGeometry().getCoordinates();
        that.areaList[areaIndex].iconcenter = that.pointIcon.getGeometry().getCoordinates();
      });
    },
    addiconSourceModify(item) {
      /* item值为undefined 说明areaList无该点位数据 */
      let that = this;
      this.modifyinter = new Modify({
        source: this.iconSource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.modifyinter.on("modifystart", function (evt) {});
      this.modifyinter.on("modifyend", function (evt) {
        let coodrs = evt.features.getArray()[0].getGeometry().getCoordinates();
        let isExistpolygon;
        that.drawSource.getFeatures().forEach(feature => {
          if (feature.get("type") === "areapolygon") {
            let extent = feature.getGeometry().getExtent();
            if (coodrs[0] <= extent[2] && coodrs[0] >= extent[0] && coodrs[1] <= extent[3] && coodrs[1] >= extent[1]) isExistpolygon = feature;
          }
        });
        /* 新增点 */
        if (isExistpolygon !== undefined && item === undefined) {
          let dragId = isExistpolygon.get("id");
          let areaIndex = that.areaList.findIndex(item => {
            return item.id === dragId;
          });
          that.setSelectData(that.areaList[areaIndex]);
          that.polygonchangefeature(evt.features.getArray()[0], 0, areaIndex);
          that.areaList[areaIndex].data.push(evt.features.getArray()[0].get("id"));
        }
        /* 删除点 */
        if (isExistpolygon === undefined && item !== undefined) {
          let areaIndex, dataIndex;
          that.areaList.forEach((item, index) => {
            item.data.forEach((elem, eIndex) => {
              if (elem === evt.features.getArray()[0].get("id")) {
                areaIndex = index;
                dataIndex = eIndex;
              }
            });
          });
          that.polygonchangefeature(evt.features.getArray()[0], 1, areaIndex);
          if (that.selectArr.length > 0) that.areaList[areaIndex].data.splice(dataIndex, 1);
        }
      });
    },
    removeModify() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = "";
    },
    removeTranslate() {
      this.map.removeInteraction(this.translateinter);
      this.translateinter = "";
    },
    /**
     * 选择绘制元素
     */
    addselectInteraction() {
      this.selectinter = new Select({
        style: feature => {
          let selectStyle = feature.getStyle();
          let score = feature.get("score");
          let type = feature.get("type");
          if (score === 1) {
            selectStyle = [new Style({
              image: new StyleIcon({
                src: feature.get("image"),
                anchor: [1.3, 0.5],
                scale: 0.5
              })
            }), new Style({
              text: new StyleText({
                textAlign: "left",
                text: feature.get("name"),
                font: `14px sans-serif`,
                offsetY: 1,
                fill: new StyleFill({
                  color: "#ffffff"
                }),
                stroke: new StyleStroke({
                  color: "#045578",
                  width: 2
                })
              })
            })];
          }
          if (type === "areapolygon") {
            selectStyle = [new Style({
              fill: new StyleFill({
                color: "rgba(255, 255, 255, 0.4)"
              }),
              stroke: new StyleStroke({
                color: "#045578",
                width: 2,
                lineDash: [6, 4]
              })
            })];
          }
          if (type === "areaicon") {
            selectStyle = [new Style({
              image: new StyleIcon({
                src: "https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png",
                scale: 1.4
              })
            })];
          }
          return selectStyle;
        }
      });
      this.map.addInteraction(this.selectinter);
      // this.selectedFeatures = this.selectinter.getFeatures()
      let that = this;
      this.selectinter.on("select", function (evt) {
        // console.log(`this.selectinter.getFeatures()`, that.selectinter.getFeatures());
        if (that.selectinter.getFeatures().getArray().length === 0) {
          that.removeModify();
          that.removeTranslate();
        } else {
          let type = that.selectinter.getFeatures().getArray()[0].get("type");
          let dragId = that.selectinter.getFeatures().getArray()[0].get("id");
          if (type && type.includes("area")) {
            /** 选中当前区域列表、ICON、LINE  **/
            let selectItem = that.areaList.find(item => {
              return item.id === dragId;
            });
            that.setSelectData(selectItem);
            that.adddrawSourceTranslate();
          } else {
            let selectItem;
            that.areaList.forEach(item => {
              if (item.data.length > 0) {
                item.data.forEach(elem => {
                  if (elem === dragId) selectItem = item;
                });
              }
            });
            console.log(`selectItem`, selectItem);
            if (selectItem) that.setSelectData(selectItem);
            that.addiconSourceModify(selectItem);
          }
        }
      });
    },
    setSelectData(select) {
      this.selectArr = [];
      select.data.forEach(item => {
        this.iconSource.getFeatures().forEach(feature => {
          if (item === feature.get("id")) this.selectArr.push(feature);
        });
      });
      this.drawSource.getFeatures().forEach(feature => {
        if (feature.get("id") === select.id) {
          if (feature.get("type") === "areaicon") this.pointIcon = feature;
          if (feature.get("type") === "areapolygon") this.polygonfeature = feature;
          if (feature.get("type") === "arealine") this.linefeature = feature;
        }
      });
    },
    /**
     * 框选绘制元素
     */
    adddragboxInteraction() {
      this.dragboxinter = new DragBox({
        condition: platformModifierKeyOnly
      });
      this.map.addInteraction(this.dragboxinter);
      this.dragboxinter.on("boxstart", () => {
        this.selectedFeatures = [];
      });
      this.dragboxinter.on("boxend", () => {
        const boxExtent = this.dragboxinter.getGeometry().getExtent();
        const worldExtent = this.map.getView().getProjection().getExtent();
        const worldWidth = getWidth(worldExtent);
        const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth);
        const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth);
        for (let world = startWorld; world <= endWorld; ++world) {
          const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0]);
          const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2]);
          const extent = [left, boxExtent[1], right, boxExtent[3]];
          const boxFeatures = this.iconSource.getFeaturesInExtent(extent).filter(feature => feature.getGeometry().intersectsExtent(extent));
          this.selectedFeatures = boxFeatures;
        }
        let that = this;
        this.resetAreaParams();
        if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawarea) {
          this.boxId = this.drawelement.drawarea.length + 1;
        } else {
          this.boxId++;
        }
        this.editareaList(this.selectedFeatures);
        this.$emit("drawarea", true);
      });
    },
    resetAreaParams() {
      this.pointIcon = "";
      this.polygonfeature = "";
      this.linefeature = "";
      this.nmaxlen = 0;
      this.drift = 0;
      this.increase = 0;
      this.transdiffx = 0;
      this.transdiffy = 0;
    },
    editareaList(val) {
      // console.log(`ratio`, this.map.getView().getResolution());
      this.viewratio = this.map.getView().getResolution();
      this.map.getLayers().getArray().forEach(item => {
        if (item.className_ === "icon") item.setZIndex(7);
        if (item.className_ === "draw") item.setZIndex(6);
      });
      this.selectArr = val;
      let extent = boundingExtent(this.selectArr.map(feature => feature.getGeometry().getCoordinates()));
      let center = getCenter(extent);
      this.pointIcon = new Feature({
        geometry: new Point(center),
        id: this.boxId,
        type: "areaicon"
      });
      this.pointIcon.setStyle(new Style({
        image: new StyleIcon({
          src: "https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png"
        })
      }));
      this.drawSource.addFeature(this.pointIcon);
      this.drift = this.viewratio * 300;
      this.increase = this.viewratio * this.ih;
      this.setpointCoordinates(center);
      this.polygonfeature = new Feature({
        geometry: new Polygon([this.getPolygonCoords()]),
        id: this.boxId,
        type: "areapolygon"
      });
      this.polygonfeature.setStyle(new Style({
        fill: new StyleFill({
          color: "rgba(255, 255, 255, 0.4)"
        }),
        stroke: new StyleStroke({
          color: "#045578",
          width: 1,
          lineDash: [6, 4]
        })
      }));
      this.drawSource.addFeature(this.polygonfeature);
      this.linefeature = new Feature({
        geometry: new LineString([center, [center[0] + this.drift - this.viewratio * 34, center[1]]]),
        id: this.boxId,
        type: "arealine"
      });
      this.linefeature.setStyle(new Style({
        stroke: new StyleStroke({
          color: "#045578",
          width: 1,
          lineDash: [6, 4]
        })
      }));
      this.drawSource.addFeature(this.linefeature);
      let dataId = this.selectArr.map(item => {
        return item.get("id");
      });
      this.areaList.push({
        id: this.boxId,
        iconcenter: center,
        data: dataId,
        datafirstcenter: this.selectArr[0].getGeometry().getCoordinates()
      });
    },
    /**
     * 区域列表新增或删除点位操作 type 0新增  1删除
     */
    polygonchangefeature(feature, type, areaIndex) {
      console.log(`type`, type === 0 ? "添加" : "删除");
      if (type === 0) this.selectArr.push(feature);
      if (type === 1) {
        let index = this.selectArr.findIndex(item => item.get("id") === feature.get("id"));
        this.selectArr.splice(index, 1);
        feature.getGeometry().setCoordinates(transform(feature.get("xy"), "EPSG:4326", "EPSG:3857"));
      }
      this.selectinter.getFeatures().clear();
      this.removeModify();
      /** 区域列表内无点位数据操作 **/
      if (this.selectArr.length === 0) {
        let boxid = this.areaList[areaIndex].id;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.get("id") === boxid) this.drawSource.removeFeature(feature);
        });
        this.areaList.splice(areaIndex, 1);
      } else {
        let center = this.pointIcon.getGeometry().getCoordinates();
        this.setpointCoordinates(center, type);
        this.polygonfeature.setGeometry(new Polygon([this.getPolygonCoords()]));
        this.areaList[areaIndex].datafirstcenter = this.selectArr[0].getGeometry().getCoordinates();
        this.areaList[areaIndex].iconcenter = this.pointIcon.getGeometry().getCoordinates();
      }
    },
    setpointCoordinates(center, type) {
      let slen = this.selectArr.length;
      let px = center[0];
      let py = Math.abs(center[1] + this.viewratio * this.ih * (slen - 1) / 2);
      this.selectArr.forEach((elem, index) => {
        let len = elem.get("name").length;
        this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
        let coords = elem.getGeometry().getCoordinates();
        let x = px + this.drift;
        if (this.transdiffx !== 0) {
          x = coords[0];
          if (type === 0 && index === slen - 1) x = this.selectArr[0].getGeometry().getCoordinates()[0];
        }
        elem.getGeometry().setCoordinates([x, py + (index !== 0 ? -index * this.increase : 0)]);
      });
    },
    getPolygonCoords() {
      return this.extentToPolygonCoords(this.setpolyonextent(this.selectArr));
    },
    setpolyonextent(features) {
      let polygonextent = boundingExtent(features.map(feature => feature.getGeometry().getCoordinates()));
      polygonextent[0] = polygonextent[0] - this.viewratio * 34;
      polygonextent[1] = polygonextent[1] - this.viewratio * 18;
      polygonextent[2] = polygonextent[2] + this.nmaxlen * 12 * this.viewratio;
      polygonextent[3] = polygonextent[3] + this.viewratio * 18;
      return polygonextent;
    },
    extentToPolygonCoords(extent) {
      return [[extent[0], extent[1]],
      // 左上角
      [extent[2], extent[1]],
      // 右上角
      [extent[2], extent[3]],
      // 右下角
      [extent[0], extent[3]],
      // 左下角
      [extent[0], extent[1]] // 闭合
      ];
    },
    drawAreaList(val) {
      // 存在点位区域列表数据
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawarea) {
        if (this.iseditpoint) this.$emit("drawarea", true);
        this.viewratio = this.map.getView().getResolution();
        this.map.getLayers().getArray().forEach(item => {
          if (item.className_ === "icon") item.setZIndex(7);
          if (item.className_ === "draw") item.setZIndex(6);
        });
        console.log(`this.drawelement.drawarea`, this.drawelement.drawarea);
        this.drawelement.drawarea.forEach(area => {
          this.pointIcon = new Feature({
            geometry: new Point(area.iconcenter),
            id: area.id,
            type: "areaicon"
          });
          this.pointIcon.setStyle(new Style({
            image: new StyleIcon({
              src: "https://p.ananas.chaoxing.com/star3/origin/93f06f6eaf18f318ce99392322d2309d.png"
            })
          }));
          this.drawSource.addFeature(this.pointIcon);
          let features = [];
          let slen = features.length;
          let px = area.datafirstcenter[0];
          let py = area.datafirstcenter[1];
          this.increase = this.viewratio * this.ih;
          this.transdiffx = area.datafirstcenter[0] - area.iconcenter[0];
          area.data.forEach((elem, index) => {
            this.iconSource.getFeatures().forEach(feature => {
              if (elem === feature.get("id")) {
                let len = feature.get("name").length;
                this.nmaxlen = this.nmaxlen <= len ? len : this.nmaxlen;
                feature.getGeometry().setCoordinates([px, py + (index !== 0 ? -index * this.increase : 0)]);
                features.push(feature);
              }
            });
          });
          let polygonextent = this.setpolyonextent(features);
          this.polygonfeature = new Feature({
            geometry: new Polygon([this.extentToPolygonCoords(polygonextent)]),
            id: area.id,
            type: "areapolygon"
          });
          this.polygonfeature.setStyle(new Style({
            fill: new StyleFill({
              color: "rgba(255, 255, 255, 0.4)"
            }),
            stroke: new StyleStroke({
              color: "#045578",
              width: 1,
              lineDash: [6, 4]
            })
          }));
          this.drawSource.addFeature(this.polygonfeature);
          /** 判断line在pointIcon 左侧(false)或右侧(true) **/
          let direction = polygonextent[0] > area.iconcenter[0];
          let polygonwidth = polygonextent[2] - polygonextent[0];
          this.linefeature = new Feature({
            geometry: new LineString([area.iconcenter, [polygonextent[0] + (direction ? 0 : polygonwidth), area.iconcenter[1]]]),
            id: area.id,
            type: "arealine"
          });
          this.linefeature.setStyle(new Style({
            stroke: new StyleStroke({
              color: "#045578",
              width: 1,
              lineDash: [6, 4]
            })
          }));
          this.drawSource.addFeature(this.linefeature);
        });
        this.areaList = this.drawelement.drawarea;
      }
    },
    /**
     * 平移绘制元素
     */
    addtranslateInteraction() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: "请先选择要平移的绘制元素",
          type: "warning"
        });
        return;
      }
      this.translateinter = new Translate({
        features: this.selectedFeatures
      });
      this.map.addInteraction(this.translateinter);
    },
    /**
     * 绘制文字
     */
    createText(val, name) {
      console.log(`绘制文字`, val);
      this.drawSource.getFeatures().forEach(feature => {
        if (feature.get("type") === 0) this.drawSource.removeFeature(feature);
      });
      let data = this.mapv2info.drawlayer;
      let iconFeatures = [];
      let list = name === "currentList" ? val : data.currentList;
      list.forEach((elem, index) => {
        let coordinate = [...data.currentCoordinate];
        let cstyle = {
          ...this.currentTextstyle
        };
        cstyle.color = (index - 1) % 3 === 0 ? cstyle.color2 : cstyle.color1;
        let space = cstyle.fontSpace ? cstyle.fontSpace : 4;
        if (cstyle.align === 0) coordinate[0] = coordinate[0] + index * (cstyle.fontSize * space * 0.001);
        if (cstyle.align === 1) coordinate[1] = coordinate[1] - index * (cstyle.fontSize * space * 0.001);
        let feature = new Feature({
          geometry: new Point(transform(coordinate, "EPSG:4326", "EPSG:3857")),
          id: elem.key,
          name: elem.label,
          type: name === "currentList" ? 0 : val,
          style: cstyle
        });
        let text = elem.label;
        if (cstyle.align === 0) {
          elem.label = elem.label.replace(/\uff08/g, "\ufe35");
          elem.label = elem.label.replace(/\uff09/g, "\ufe36");
          text = elem.label.split("").join("\n");
        }
        feature.setStyle(new Style({
          text: new StyleText({
            text: text,
            font: `${cstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
            textBaseline: "top",
            textAlign: "left",
            fill: new StyleFill({
              color: cstyle.color
            })
          })
        }));
        iconFeatures.push(feature);
      });
      this.drawSource.addFeatures(iconFeatures);
      if (name === "drawtextblocksum") {
        this.SET_MAPDRAWLAYERITEM({
          currentList: []
        });
        this.showtexthelp();
      }
    },
    showtexthelp() {
      this.drawtextsingleflag = false;
      this.helpTooltipElement.innerHTML = "点击选择位置后 添加点位名称";
      this.helpTooltipElement.classList.remove("hidden");
    },
    /**
     * 保存绘制数据
     */
    saveDrawHandle() {
      let feature = this.drawSource.getFeatures();
      let jsonObj = new GeoJSON().writeFeatures(feature);
      this.SET_MAPDRAWLAYERITEM({
        drawJson: feature.length > 0 ? jsonObj : ""
      });
    },
    /**
     * 创建非遗数据点位
     */
    createculturalPoint(val) {
      // 中国禹迹图 总地图 formUserId === '1220314818'
      if (val.length === 0 || this.$route.query.formUserId === "1220314818") return;
      let showArr = val.filter(item => {
        return item.itemformdata.correlation_map === "是" && item.itemformdata.correlation_address.length > 0;
      });
      // console.log(showArr);
      showArr.forEach(elem => {
        let item = elem.itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: `${item[75]} ${item.place_name}`,
          image: item.icon ? item.icon : this.defaulticon,
          icon: ""
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: "",
          xy: [x, y],
          score: 1
        });
        pointfeature.setStyle([new Style({
          image: new StyleIcon({
            src: obj.image,
            anchor: [1.3, 0.5],
            scale: 0.5
          })
        }), new Style({
          text: new StyleText({
            textAlign: "left",
            text: obj.name,
            font: `14px sans-serif`,
            offsetY: 1,
            fill: new StyleFill({
              color: "#333333"
            }),
            stroke: new StyleStroke({
              color: "#ffffff",
              width: 1
            })
          })
        })]);
        this.iconSource.addFeature(pointfeature);
      });
      // 龙岩地图添加 随机显示 gif动图 20240529 后面可以在高级设置的 交互效果 做统一对接
      if (this.$route.query.fid === "138053") {
        this.setpointlight(showArr);
      }
    },
    setpointlight(arr) {
      let that = this;
      let len = arr.length;
      let max = len / 3;
      let newIndexArr = [];
      for (let i = 0; i < 6; i++) {
        let randIndex = Math.floor(Math.random() * len);
        if (!newIndexArr.includes(randIndex)) newIndexArr.push(randIndex);
      }
      newIndexArr.forEach(elem => {
        let item = arr[elem].itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: this.lightIcon[Math.floor(Math.random() * 3)],
          icon: "",
          gif: this.lightIcon[Math.floor(Math.random() * 3)]
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: arr[elem].id,
          name: obj.name,
          image: obj.image,
          icon: "",
          xy: [x, y],
          score: 1,
          light: true
        });
        const gifUrl = obj.gif;
        const gif = gifler(gifUrl);
        gif.frames(document.createElement("canvas"), function (ctx, frame) {
          if (!pointfeature.getStyle()) {
            pointfeature.setStyle(new Style({
              image: new StyleIcon({
                img: ctx.canvas,
                opacity: 1,
                imgSize: [frame.width, frame.height],
                anchor: [0.5, 0.5],
                scale: 0.02
              })
            }));
          }
          ctx.clearRect(0, 0, frame.width, frame.height);
          ctx.drawImage(frame.buffer, frame.x, frame.y);
          that.map.render();
        }, true);
        this.iconSource.addFeature(pointfeature);
      });
    },
    addpopOverLay(coordinate) {
      const container = document.querySelector(".popcontainer-style1");
      this.overlay = new Overlay({
        element: container,
        positioning: "bottom-left"
      });
      this.overlay.setPosition(fromLonLat(coordinate));
      this.map.addOverlay(this.overlay);
    },
    removeAlliconsource() {
      this.iconSource.clear();
    },
    removeDrawsource() {
      this.drawSource.clear();
    },
    removeRoutesource() {
      this.routeSource.clear();
    },
    createRoute(val) {
      console.log(`createRoute`, val);
      if (val.length === 0) return;
      this.routeSource.clear();
      let routeFeatures = [];
      this.allpath = [];
      val.forEach((item, index) => {
        let linestyle = {
          ...item.style
        };
        if (linestyle.lineDash.length > 0) linestyle.lineDash = linestyle.lineDash.map(item => {
          return linestyle.width * item;
        });
        item.path.forEach((child, cdi) => {
          let routeFeature = new Feature({
            id: item.id ? item.id : 100,
            type: "allroute",
            geometry: new LineString(child)
          });
          routeFeature.setStyle(new Style({
            stroke: new StyleStroke(linestyle)
          }));
          routeFeatures.push(routeFeature);
          this.allpath.push(...child);
        });
      });
      this.routeSource.addFeatures(routeFeatures);
      this.startMove();
      // 移动端显示路线后 路线的初始经纬度挪到地图的中心点 防止看不到
      if (this.isMobile && val.length === 1) this.map.getView().animate({
        center: val[0].path[0][0]
      });
    },
    startMove() {
      this.geoMarker = new Feature({
        type: "geoMarker",
        geometry: new Point(this.allpath[0])
      });
      this.geoMarker.setStyle(new Style({
        // 设置标记样式
        image: new StyleIcon({
          anchor: [0.5, 1],
          // 偏移位置
          src: "https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png",
          rotateWithView: true
        })
      }));
      this.routeSource.addFeature(this.geoMarker);
      this.nowDate = new Date().getTime();
      this.animating = true;
      this.routeLayer.on("postrender", this.moveFeature);
      this.map.render();
    },
    moveFeature(event) {
      let vectorContext = olRender.getVectorContext(event);
      let frameState = event.frameState;
      let speed = 30;
      if (this.animating) {
        let elapsedTime = frameState.time - this.nowDate;
        let index = Math.round(speed * elapsedTime / 1000);
        // 进度条
        this.moveprogress = Math.floor(100 / this.allpath.length * (speed * elapsedTime) / 1000);
        if (index >= this.allpath.length) {
          this.moveprogress = "100";
          this.stopMove(true);
          return;
        }
        let currentPoint = new Point(this.allpath[index]);
        let feature = new Feature(currentPoint);
        vectorContext.drawFeature(feature, new Style({
          // 设置标记样式
          image: new StyleIcon({
            anchor: [0.5, 1],
            // 偏移位置
            src: "https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png",
            rotateWithView: true
          })
        }));
      }
      // tell OpenLayers to continue the postrender animation
      this.map.render();
    },
    stopMove(ended) {
      this.moveprogress = 0;
      this.animating = false;
      let coord = ended ? this.allpath[this.allpath.length - 1] : this.allpath[0];
      this.geoMarker.getGeometry().setCoordinates(coord);
      //remove listener
      this.routeLayer.un("postrender", this.moveFeature); // 删除侦听器
    },
    getAnchor(name, anchor) {
      if (name == "浙江外国语学院") {
        return [5.5, 0.5];
        // return [8.2,-13.2]
      }
      if (name == "浙江开放大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江理工大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江树人学院") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江警察学院") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江传媒学院") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江科技大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江财经大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江农林大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "中国计量大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "杭州师范大学") {
        return [5.2, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙江工业大学") {
        return [5.1, 0.5];
        // return [8,-13.2]
      }
      if (name == "中国美术学院") {
        return [5.1, 0.5];
        // return [8,-13.2]
      }
      if (name == "杭州电子科技大学") {
        return [5.9, 0.5];
        // return [8.7,-13.2]
      }
      if (name == "西湖大学") {
        return [4.4, 0.5];
        // return [7.3,-13.2]
      }
      if (name == "浙江大学") {
        return [4.4, 0.5];
        // return [7.3,-13.2]
      }
      if (name == "浙江中医药大学") {
        return [5.4, 0.5];
        // return [8.4,-13.2]
      }
      if (name == "浙江工商大学") {
        return [5, 0.5];
        // return [8,-13.2]
      }
      if (name == "杭州电子科技大学信息工程学院") {
        return [8.2, 0.5];
        // return [11.3,-13.2]
      }
      if (name == "浙江工商大学杭州商学院") {
        return [7, 0.5];
        // return [10,-13.2]
      }
      if (name == "杭州师范大学钱江学院") {
        return [6.5, 0.5];
        // return [9.5,-13.2]
      }
      if (name == "浙江水利水电学院") {
        return [5.7, 0.5];
        // return [8.7,-13.2]
      }
      if (name == "浙江音乐学院") {
        return [5, 0.5];
        // return [8,-13.2]
      }
      if (name == "浙大城市学院") {
        return [5, 0.5];
        // return [8,-13.2]
      }
      if (name == "湖州师范学院") {
        return [4.5, 0.5];
      }
      if (name == "湖州学院") {
        return [3.8, 0.5];
      }
      if (name == "绍兴理工学院") {
        return [3.8, 0.5];
      }
      if (name == "浙江农林大学暨阳学院") {
        return [5.3, 0.5];
      }
      if (name == "浙江理工大学科技与艺术学院") {
        return [6.7, 0.5];
      }
      if (name == "浙江工业大学之江学院") {
        return [5.5, 0.5];
      }
      if (name == "浙江越秀外国语学院") {
        return [5.1, 0.5];
      }
      if (name == "绍兴文理学院") {
        return [3.7, 0.5];
      }
      if (name == "浙江财经大学东方学院") {
        return [5.5, 0.5];
      }
      if (name == "嘉兴南湖学院") {
        return [4, 0.5];
      }
      if (name == "嘉兴大学") {
        return [3.2, 0.5];
      }
      if (name == "浙江海洋大学") {
        return [3.8, 0.5];
      }
      if (name == "宁波大学") {
        return [3.8, 0.5];
      }
      if (name == "浙江万里学院") {
        return [4.7, 0.5];
      }
      if (name == "宁波工程学院") {
        return [4.7, 0.5];
      }
      if (name == "宁波财经学院") {
        return [4.7, 0.5];
      }
      if (name == "浙大宁波理工学院") {
        return [5.5, 0.5];
      }
      if (name == "宁波大学科学技术学院") {
        return [6.3, 0.5];
      }
      if (name == "台州学院") {
        return [3, 0.5];
      }
      if (name == "温州大学") {
        return [3, 0.5];
      }
      if (name == "温州医科大学") {
        return [3.7, 0.5];
      }
      if (name == "温州肯恩大学") {
        return [3.7, 0.5];
      }
      if (name == "温州商学院") {
        return [3.3, 0.5];
      }
      if (name == "温州理工学院") {
        return [3.7, 0.5];
      }
      if (name == "温州医科大学仁济学院") {
        return [5.3, 0.5];
      }
      if (name == "浙江师范大学") {
        return [4.2, 0.5];
      }
      if (name == "浙江师范大学行知学院") {
        return [5.8, 0.5];
      }
      if (name == "中国计量大学现代科技学院") {
        return [6.5, 0.5];
      }
      if (name == "上海财经大学浙江学院") {
        return [5.7, 0.5];
      }
      if (name == "衢州学院") {
        return [3.2, 0.5];
      }
      if (name == "丽水学院") {
        return [3.2, 0.5];
      }
      if (name == "杭州医学院") {
        return [4.4, 0.5];
        // return [7.4,-13.2]
      }
      return anchor;
    },
    loadLocation(val) {
      return;
      this.locationSource.clear();
      if (Object.keys(val).length > 0 && val.lng && val.lat) {
        let gd = bd_decrypt(val.lng, val.lat);
        let feature = new Feature({
          geometry: new Point(fromLonLat([gd.lng, gd.lat])),
          id: 1,
          type: "location"
        });
        feature.setStyle(new Style({
          image: new StyleIcon({
            src: this.locationicon,
            anchor: [0.5, 0.5],
            scale: 0.7,
            rotateWithView: true
          })
        }));
        this.locationSource.addFeature(feature);
      }
    }
  }
};